import Vue from 'vue';
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

export default class Google {

    static async get(path, contentType="application/json") {
        try {
          let url = this.getUrl(path);
          let headers = await this.getHeaders(contentType);
          let response = await Vue.axios.get(url, headers);
          return response.data;
        }
        catch (error) {
            console.error(`GET ${path}`, error);
            throw error;
        }
    }

    static async post(path, params, contentType="application/json") {
        try {
          let url = this.getUrl(path);
          let headers = await this.getHeaders(contentType);
          let response = await Vue.axios.post(url, params, headers);
          return response.data;
        }
        catch (error) {
            console.error(`POST ${path}`, error);
            throw error;
        }
    }

    static async put(path, params, contentType="application/json") {
        try {
          let url = this.getUrl(path);
          let headers = await this.getHeaders(contentType);
          let response = await Vue.axios.put(url, params, headers);
          return response.data;
        }
        catch (error) {
            console.error(`PUT ${path}`, error);
            throw error;
        }
    }

    static getUrl(url) {
        if (url.includes("?")) {
          return url + "&key=" + process.env.VUE_APP_GOOGLE_API_KEY;
        }
        return url + "?key=" + process.env.VUE_APP_GOOGLE_API_KEY;
    }

    static async getHeaders(contentType="application/json") {
        let item = await Storage.get({ key: "user" });
        if (item && item.value) {
          let json = JSON.parse(item.value);
          return {
              headers: {
                  "Content-Type": contentType,
                  Authorization: `Bearer ${json.token}`
              }
          };
        }
        return { };
    }
}